import angular from "angular";
import AjaxHelper from "./ng.helper/ajax.helper";
import $ from "jquery";
import { sizeDesktopSpacer } from "./helper/sizeDesktopSpacer";
import CheckoutController from "./controller/checkout.controller";
import CrossSellService from "./service/cross-sell.service";
import UserControlService from "./service/user-control.service";
import NGLocale from "./modules/angular-locale_de-de.module";
import WatcherService from "./service/watcher.service";
import CartController from "./controller/cart.controller";
import CrossSellController from "./controller/cross-sell.controller";
import PaymentController from "./controller/payment.controller";
import ProductController from "./controller/product.controller";
import CarouselDirective from "./directive/carousel.directive";
import ImageOrientationDirective from "./directive/image-orientation.directive";
import DateformatDirective from "./directive/dateformat.directive";
import ModalDirective from "./directive/modal.directive";
import ResidualTextDirective from "./directive/residualtext.directive";
import FormatEventTimeFilter from "./filter/format-event-time.filter";
import TrustedFilter from "./filter/toTrusted.filter";
import CartService from "./service/cart.service";
import ConfigService from "./service/config.service";
import DiscountService from "./service/discount.service";
import MailcheckerService from "./service/mailchecker.service";
import PaymentDataHelper from "./ng.helper/paymentdata.helper";
import UserController from "./controller/user.controller";
import ShippingMethodService from "./service/shipping-method.service";
import TicketFormatService from "./service/ticket-format.service";
import VoucherService from "./service/voucher.service";
import FallbackDirective from "./directive/fallback.directive";
import PlaceHolderClickDirective from "./directive/placeholder-click.directive";
import TimeoutDirective from "./directive/timeout.directive";
import CartHelper from "./ng.helper/cart.helper";
import { leanModal } from "./plugins/leanModal";
import { changePriceOption } from "./helper/changePriceOption";
import HeaderScroll from "./class/HeaderScroll";

new HeaderScroll();

window.changePriceOption = changePriceOption;

$.fn.extend({
    leanModal,
});

angular.module("ngLocale", [], [
    "$provide",
    NGLocale
]);


let spinnerMaxDisplayDuration = 3000;
let spinnerStopped = false;

function stopSpinner() {
    document.getElementById('wrapper').style.display = 'block';
    document.getElementById('spinner').style.display = 'none';
    sizeDesktopSpacer();
    spinnerStopped = true;
}

$(window).on("load", function () {
    if (!spinnerStopped) {
        stopSpinner();
    }
});

$(window).resize(function () {

    sizeDesktopSpacer();
});

setTimeout(function () {
    if (!spinnerStopped) {
        stopSpinner();
    }
}, spinnerMaxDisplayDuration);

$(document).ready(function () {
    // no css because some clients have her own custom_css
    $('.progressbar').css('background-color', $('body').css('background-color'));
    $('a.modalTrigger').leanModal({ closeButton: '.close' });

    // Pull out all modals from nested elements and attach them to the wrapper
    $('.modal').each(function () {
        $(this).appendTo('#wrapper');
    });
});

const app = angular.module("app", []);

app.factory('CartHelper', [
    'Cart',
    'CrossSell',
    '$q',
    '$timeout',
    'Voucher',
    'ShippingMethodService',
    'Discount',
    'TicketFormatService',
    CartHelper
]);

app.controller('CheckoutController', [
    "$scope",
    "$http",
    "$sce",
    "$httpParamSerializerJQLike",
    "AjaxHelper",
    "CrossSell",
    "UserControl",
    "CartHelper",
    "Watchers",
    "Config",
    "Cart",
    "TicketFormatService",
    "ShippingMethodService",
    "Voucher",
    "formatEventTimeFilter",
    "$filter",
    "Discount",
    "$timeout",
    'PaymentDataHelper',
    CheckoutController
]);

app.directive('fallbackSrc', FallbackDirective);

app.directive('placeholderclick', [
    '$animate',
    PlaceHolderClickDirective
]);

app.directive('timeout', TimeoutDirective);

app.factory('CrossSell', [
    'Cart',
    '$q',
    'Discount',
    CrossSellService
]);

app.factory('UserControl', [
    'dateFilter',
    '$timeout',
    UserControlService
]);

app.factory('Watchers', [
    'Cart',
    'Discount',
    'Config',
    '$timeout',
    'Voucher',
    '$filter',
    WatcherService
]);

app.controller('CartController', [
    '$scope',
    'Cart',
    'Voucher',
    '$interval',
    'Discount',
    '$timeout',
    CartController
]);

app.controller('CrossSellController', [
    '$scope',
    '$timeout',
    'Cart',
    'CrossSell',
    CrossSellController
]);

app.controller('PaymentController', [
    '$scope',
    '$timeout',
    'Voucher',
    'Cart',
    'Discount',
    PaymentController
]);

app.controller('ProductController', [
    '$scope',
    '$sce',
    ProductController
]);

app.controller('UserControlController', [
    '$scope',
    '$timeout',
    'UserControl',
    'Mailchecker',
    UserController
]);

app.directive('carousel', [
    'imgorientationDirective',
    CarouselDirective
]);

app.directive('imgorientation', [
    ImageOrientationDirective
]);

app.directive('modal', [
    ModalDirective
]);


app.directive('residualtext', [
    'Voucher',
    'currencyFilter',
    ResidualTextDirective
]);

app.filter('formatEventTime', FormatEventTimeFilter);

app.filter('toTrusted', [
    '$sce',
    TrustedFilter
]);

app.factory('Cart', [
    'TicketFormatService',
    'ShippingMethodService',
    'Config',
    'Discount',
    CartService
]);

app.factory('Config', [
    ConfigService
]);


app.factory('Discount', [
    '$sce',
    '$filter',
    '$timeout',
    DiscountService
]);

app.factory('Mailchecker', [
    'Config',
    MailcheckerService
]);

app.factory('PaymentDataHelper', [
    'UserControl',
    PaymentDataHelper
]);


app.factory('ShippingMethodService', [
    ShippingMethodService
]);

app.factory('TicketFormatService', [
    'Config',
    TicketFormatService
]);

app.factory('Voucher', [
    "Cart",
    "$q",
    "Discount",
    VoucherService
]);

app.factory('AjaxHelper', AjaxHelper);

app.directive('dateformat', [
    'dateFilter',
    DateformatDirective
]);
